import { gql } from "@apollo/client";

export const CHECKIN_SENTRY_SESSION_MUTATION = gql`
    mutation {
        checkInToActiveSentrySession {
            success
        }
    }
`;

export const CLAIM_SPOILS_SESSION_MUTATION = gql`
    mutation {
        claimActiveSpoilsSession {
            success
        }
    }
`;

export const CLAIM_DRINK_SESSION_MUTATION = gql`
    mutation {
        claimActiveDrinkSession {
            success
        }
    }
`;

export const CLAIM_CLAN_SPOILS_SESSION_MUTATION = gql`
    mutation {
        claimActiveClanSpoilsSession {
            success
        }
    }
`;

export const CHECKIN_SESSION_MUTATION = gql`
    mutation {
        checkInToActiveSession {
            success
        }
    }
`;
export const CHECKIN_RAID_SESSION_MUTATION = gql`
    mutation {
        checkInToActiveRaidSession {
            success
        }
    }
`;

export const REDEEM_WHEEL_OF_HAMINGJA_TOKEN_MUTATION = gql`
    mutation RedeemWheelOfHamingjaToken {
        redeemWheelOfHamingjaToken {
            success
        }
    }
`;

export const CLAIM_HYPE_TRAIN_LOOT_SESSION_MUTATION = gql`
    mutation {
        claimHypeTrainLootSession {
            prize
            success
        }
    }
`;

export const REDEEM_WHEEL_OF_HAMINGJA_SESSION_MUTATION = gql`
    mutation RedeemWheelOfHamingjaSession {
        redeemWheelOfHamingjaSession {
            success
        }
    }
`;

export const START_WHEEL_OF_HAMINGJA_REDEMPTION_SESSION_MUTATION = gql`
    mutation StartWheelOfHamingjaRedemptionSession {
        startWheelOfHamingjaRedemptionSession {
            success
        }
    }
`;

export const END_WHEEL_OF_HAMINGJA_REDEMPTION_SESSION_MUTATION = gql`
    mutation EndWheelOfHamingjaRedemptionSession {
        endWheelOfHamingjaRedemptionSession {
            success
        }
    }
`;

export const START_DRINK_SESSION_MUTATION = gql`
    mutation StartDrinkSession($pointsReward: Int!) {
        startDrinkSession(pointsReward: $pointsReward) {
            success
        }
    }
`;

export const END_DRINK_SESSION_MUTATION = gql`
    mutation EndDrinkSession {
        endDrinkSession {
            success
        }
    }
`;

export const START_SPOILS_SESSION_MUTATION = gql`
    mutation StartSpoilsSession($pointsReward: Int!) {
        startSpoilsSession(pointsReward: $pointsReward) {
            success
        }
    }
`;

export const START_CLAN_SPOILS_SESSION_MUTATION = gql`
    mutation StartClanSpoilsSession($pointsReward: Int!, $clanTag: String!) {
        startClanSpoilsSession(pointsReward: $pointsReward, clanTag: $clanTag) {
            success
        }
    }
`;
